import { Badge } from '@/components/ui/badge';
import type { Task } from '@rock/types';
import { assertUnreachable } from '@rock/util';
import type { FC } from 'react';

export const TaskStatusBadge: FC<{ status: Task['status'] }> = ({ status }) => {
    switch (status) {
        case 'completed':
            return <Badge className="bg-green-600">Completed</Badge>;
        case 'skipped':
            return <Badge variant="secondary">Skipped</Badge>;
        case 'pending':
            return <Badge variant="outline">Pending</Badge>;
        case 'orphaned':
            return <Badge variant="destructive">Orphaned</Badge>;
        default:
            assertUnreachable(status);
    }
};
